/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
  GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams,
  GetUserRequestsByExternalIdWatchdocsUserRequestId400,
} from '../entities/GetUserRequestsByExternalIdWatchdocsUserRequestId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUserRequestsByExternalIdWatchdocsUserRequestId } from '../api/getUserRequestsByExternalIdWatchdocsUserRequestId'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey = (
  watchdocs_user_request_id: GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams['watchdocs_user_request_id'],
) => [{ url: '/user-requests/by-external-id/:watchdocs_user_request_id', params: { watchdocs_user_request_id: watchdocs_user_request_id } }] as const

export type GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey = ReturnType<typeof getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey>

export function getUserRequestsByExternalIdWatchdocsUserRequestIdQueryOptions(
  watchdocs_user_request_id: GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams['watchdocs_user_request_id'],
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const queryKey = getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey(watchdocs_user_request_id)
  return queryOptions<
    GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
    ResponseErrorConfig<GetUserRequestsByExternalIdWatchdocsUserRequestId400>,
    GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!watchdocs_user_request_id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getUserRequestsByExternalIdWatchdocsUserRequestId(watchdocs_user_request_id, config)
    },
  })
}

/**
 * @description Получение заявки водителя таксопарка по внешнему ID
 * @summary Получение заявки водителя таксопарка по внешнему ID
 * {@link /user-requests/by-external-id/:watchdocs_user_request_id}
 */
export function useGetUserRequestsByExternalIdWatchdocsUserRequestId<
  TData = GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
  TQueryData = GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
  TQueryKey extends QueryKey = GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey,
>(
  watchdocs_user_request_id: GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams['watchdocs_user_request_id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
        ResponseErrorConfig<GetUserRequestsByExternalIdWatchdocsUserRequestId400>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey(watchdocs_user_request_id)

  const query = useQuery(
    {
      ...(getUserRequestsByExternalIdWatchdocsUserRequestIdQueryOptions(watchdocs_user_request_id, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUserRequestsByExternalIdWatchdocsUserRequestId400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}